import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { api_gateway } from '../../conexoes/api'
import {
  atualizarMensagemCabecalhoSelecionada,
  mudarManejador,
  revelarMensagemCabecalhoSelecionada
} from '../../redux/actions/index'
import { useGlobal } from '../../stores/useGlobal.js'
import decryptJWT from '../../utils/decryptJWT'
import '../../css/telaInicial/telaInicial.css'

function TelaInicial() {
  const despacho = useDispatch()
  const { setIsLoadingGlobal } = useGlobal()
  let revelarMensagemCabecalho = useSelector(
    (state) => state.mensagensState.revelarMensagemCabecalhoSelecionada
  )

  useEffect(() => {
    setIsLoadingGlobal(true)
    despacho(mudarManejador('telaInicial'))

    async function handleCarregarPermissoes() {
      const displayedMessages =
        JSON.parse(localStorage.getItem('displayedMessages')) || []

      let url = `m1/consultar/mensagem?cd_pav_usuario_destinatario=${decryptJWT('codigo')}&fl_lido=0&fl_exibir_inicio=1&paginaAtual=0&carregarLimit=10`
      if (displayedMessages.length > 0) {
        url += `&displayedMessages=${encodeURIComponent(displayedMessages)}`
      }
      const response = await api_gateway.get(url)

      if (response.data.dados.length > 0) {
        response.data.dados.forEach((item) => {
          if (!displayedMessages.includes(item.cd_msg_mensagem)) {
            despacho(atualizarMensagemCabecalhoSelecionada(item))
            despacho(revelarMensagemCabecalhoSelecionada(true))
            displayedMessages.push(item.cd_msg_mensagem)
          }
        })

        localStorage.setItem(
          'displayedMessages',
          JSON.stringify(displayedMessages)
        )
      } else {
        handleConfirmarMensagensLogin()
      }

      setIsLoadingGlobal(false)
    }

    handleCarregarPermissoes()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revelarMensagemCabecalho])

  async function handleConfirmarMensagensLogin() {
    localStorage.setItem('recebeuMensagemLogin', true)
  }

  return (
    <>
      <div className="container-tela-inicial fundo-cor-5">
        <div className="texto-bem-vindo fonte-cor-1">Bem-vindo!</div>
        <div className="container-imagem-tela-inicial">
          <img
            alt="telaInicial"
            className="imagem-tela-inicial"
            src="https://veye.s3.sa-east-1.amazonaws.com/icones/tela_inicial_v2.svg"
          />
        </div>
      </div>
    </>
  )
}

export default TelaInicial
